import {Link} from "react-router-dom";
import {PATHS} from "../../../../../../../routers/utils/Paths.links";
import {CHILD_PROFILE_PATHS, dataForProfile} from "../../../../../../ProfilePage/components/Sidebar/Sidebar";
import {PATHS_API} from "../../../../../../../../enum";
import {useUserStore} from "../../../../../../../../modules/shop/user/store";
import {useHasPersonalProducts} from "../../../../../../../hooks/useHasPersonalProducts";

const ContentProfile = ({menuRef, setActive}) => {
    const user = useUserStore(store => store.user)
    const hasPersonalProducts = useHasPersonalProducts();

    const visibleProfileItems = dataForProfile.filter((item) =>
        item.to !== CHILD_PROFILE_PATHS.PERSONAL_PRODUCTS || hasPersonalProducts
    );

    return (
        <div className="content-profile">
            { user?.steamId && visibleProfileItems.map((item, idx ) =>
                    <Link
                        key={idx}
                        ref={menuRef}
                        className="burger-content-btn"
                        to={PATHS.PROFILE + item.to}
                        onClick={() => setActive(false)}
                    >
                        { item.text }
                    </Link>

            )}
            <div className="static-burger-btn">
                <Link
                    className="burger-content-btn"
                    to={PATHS.SHOP}
                    onClick={() => setActive(false)}
                >
                    Повернуться до магазину
                </Link>
            </div>
            { user?.steamId ?
                <div className="d-flex just-content-center">
                    <a
                        style={{"textDecoration" : "none", margin: "10px 0 40px", width: "200px", display: "flex", justifyContent: "center"}}
                        className='btn'
                        href={PATHS_API.LOGOUT}
                    >
                        Вийти з облікового запису
                    </a>
                </div>
                :
                <a style={{"textDecoration" : "none", margin: "20px 0", display: "flex", justifyContent: "center"}} className='btn' href={PATHS_API.LOGIN}>
                    Вхід
                </a>
            }
        </div>
    );
};

export default ContentProfile;